module.exports = "./img/c3e4b2f39e911450331109fd51f5bf18.jpg";